module.exports = __webpack_public_path__ + "img/BAU Seniors_28.33b53cd4.jpg";